<template>
  <div class="modal-main">
    <Modal
      v-model="show"
      :title="modalTitle"
      width="600"
      footer-hide
      @on-visible-change="getModalChange"
    >
      <div class="main">
        <p style="padding: 8px 0">
          请输入{{ phoneNo | fliterPhone }}收到的验证码，进行确证操作。
        </p>
        <div class="input-main">
          <Input
            v-model="phoneCode"
            placeholder="请输入短信验证码"
            maxlength="5"
            style="width: 300px"
          ></Input>
          <p
            class="msg-text"
            :class="phoneNo.length === 0 ? 'msg-disabled' : ''"
            @click="handleSend"
          >
            {{ msgText }}
          </p>
        </div>
        <p v-if="phoneCode.length === 0" class="msg-error">{{ errorStr }}</p>
      </div>
      <div class="btn-block">
        <Button :loading="loading" @click="handleCancel">取消</Button>
        <Button
          type="primary"
          :disabled="btnDisabled"
          :loading="loading"
          @click="handleOk"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/request/common/index';
import orderCenterApi from '@/request/orderCenter/index.js';
import { fliterPhone } from '@/utils/utils';
export default {
  filters: {
    fliterPhone(phone) {
      if (phone) {
        return fliterPhone(phone);
      } else {
        return '--';
      }
    }
  },
  props: {
    modalTitle: {
      type: String,
      default: '短信验证'
    },
    checkType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      phoneCode: '',
      phoneNo: '18901513234',
      msgText: '获取验证码',
      errorStr: '',
      timer: null,
      loading: false
    };
  },
  computed: {
    ...mapState(['userInfo']),
    btnDisabled() {
      if (this.phoneCode.length !== 5) {
        return true;
      } else if (this.phoneNo.length === 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleShow() {
      //  this.phoneCode = '88888';
      this.msgText = '获取验证码';
      this.phoneCode = '';
      this.show = true;
    },
    // 获取用户的手机号

    handleOk() {
      // this.show = false;
      this.loading = true;
      this.$emit('sendCode', this.phoneCode);
    },
    handleClose() {
      this.loading = false;
      this.show = false;
    },
    handleCancel() {
      this.loading = false;
      this.show = false;
    },
    setErrorStr(error) {
      this.phoneCode = '';
      this.errorStr = error;
    },
    // 获取模态框状态，当关闭模态框的时候需要清除定时器
    getModalChange(status) {
      if (!status) {
        clearInterval(this.timer);
      }
    },
    // 发送短信
    async handleSend() {
      if (this.phoneNo.length === 0) {
        return;
      }
      if (this.msgText !== '获取验证码') {
        return null;
      }
      this.credential = await this.sendMsg();

      let second = 60;
      this.msgText = `${second}s后获取`;
      // this.countDown = true;
      this.timer = setInterval(() => {
        if (second === 0) {
          clearInterval(this.timer);
          // this.countDown = false;
          this.msgText = '获取验证码';
          return false;
        }
        second--;
        this.msgText = `${second}s后获取`;
      }, 1000);
    },
    async sendMsg() {
      return new Promise(async resolve => {
        const res = await orderCenterApi.getDivideConfigMsg({
          checkType: this.checkType
        });
        if (res.status === 200) {
          this.$Message.success('发送成功，请注意查收');
          resolve(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.input-main {
  padding: 16px 0;
  position: relative;
  width: 300px;
  .msg-text {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #488ffa;
    cursor: pointer;
  }
  .msg-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
.msg-error {
  color: red;
}
.btn-block {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 24px;
  }
}
</style>
